import { render, staticRenderFns } from "./psychoStuRecordDialog.vue?vue&type=template&id=1d15deed&"
import script from "./psychoStuRecordDialog.vue?vue&type=script&lang=js&"
export * from "./psychoStuRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports